import ActivityLogs from 'components/logs/ActivityLogs';
import AuditTrails from 'components/logs/AuditTrails';
import EmailLogs from 'components/logs/EmailLogs';
import LogsHeader from 'components/logs/LogsHeader';
import LogsTabs from 'components/logs/LogsTabs';
import { useState } from 'react';

export default function Logs() {
  const [activeTab, setActiveTab] = useState('activity');
  const [selectedTime, setSelectedTime] = useState('all');
  const [activityFilters, setActivityFilters] = useState({
    userName: '',
    userType: '',
    activity: '',
    status: '',
    startDate: null,
    endDate: null,
    search: '',
    organization: '',
    statuses: []
  });

  const [emailFilters, setEmailFilters] = useState({
    emailType: '',
    status: '',
    sendTo: '',
    date: '',
    startDate: null,
    endDate: null,
    search: '',
    organization: ''
  });

  const [auditFilters, setAuditFilters] = useState({
    userName: '',
    userType: '',
    change: '',
    date: '',
    startDate: null,
    endDate: null,
    search: '',
    organization: ''
  });

  return (
    <div className="px-6 pb-3 overflow-hidden overflow-y-auto h-full relative">
      <div className="pt-6 mb-6">
        <LogsHeader selectedTime={selectedTime} setSelectedTime={setSelectedTime} />
      </div>
      
      <div className="sticky top-0 z-10 bg-[#232323] pb-2 pt-2">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-xl font-semibold text-white">Logs Management</h1>
        </div>

        <LogsTabs 
          activeTab={activeTab} 
          onTabChange={setActiveTab}
          activityFilters={activityFilters}
          setActivityFilters={setActivityFilters}
          emailFilters={emailFilters}
          setEmailFilters={setEmailFilters}
          auditFilters={auditFilters}
          setAuditFilters={setAuditFilters}
        >
          {activeTab === 'activity' && (
            <ActivityLogs filters={activityFilters} setFilters={setActivityFilters} />
          )}
          {activeTab === 'email' && (
            <EmailLogs filters={emailFilters} setFilters={setEmailFilters} />
          )}
          {activeTab === 'audit' && (
            <AuditTrails filters={auditFilters} setFilters={setAuditFilters} />
          )}
        </LogsTabs>
      </div>
    </div>
  );
} 